import countryList from '../../utils/countryList';
export const FETCH_DISEASES = '/disease';
export const FETCH_AFRICA_SUMMARY = 'https://corona.lmao.ninja/v2/continents/Africa?&strict';
export const FETCH_COUNTRIES_DATA = `https://corona.lmao.ninja/v2/countries/${countryList?.join(',')}`

